/**
 * Sliders component.
 */
import MainContext from '../../../../shared/components/utils/context/mainContext';
import SliderControls from '@components/sections/sliders/sliderControls';
import SliderList from '../list/sliderList/sliderList';
import useSliderList from '@components/sections/list/sliderList/useSliderList';
import { useContext } from 'react';

/**
 * Sliders component that displays the main slider section.
 *
 * @returns {JSX.Element} The sliders container with background and list components
 */
export default function Sliders() {
  // ------------------------------------------------------------
  // Initialization
  // ------------------------------------------------------------

  const { callbacks, props } = useSliderList();
  const { display } = useContext(MainContext);

  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------

  return display?.sliders ? (
    <>
      <SliderControls
        arrows={callbacks.arrows}
        controls={callbacks.controls}
        dots={props.paginationDots}
      />
      <SliderList {...props.list} {...callbacks.list} />
    </>
  ) : null;
}
